import injectCSS from "../html/inject-css";

/**
 * You should give this tag two children. The first will be shown by default
 * and corresponds to checked=false (the default). If you set `.checked` true,
 * then the second will be shown. Clicking on the element will toggle the checked
 * and raise a change event.
 */
export class GraphicToggle extends HTMLElement {

    constructor(checked: boolean = false) {
        super();

        injectCSS(STYLESHEET);

        this.checked = checked;

        this.addEventListener('click', () => {
            this.checked = !this.checked;
            this.dispatchEvent(new CustomEvent('change', {bubbles: true}));
        });
    }


    get checked(): boolean {
        return this.hasAttribute('checked');
    }

    set checked(checked: boolean) {
        if(checked) {
            this.setAttribute('checked', '');
        } else {
            this.removeAttribute('checked');
        }
    }
}
export default GraphicToggle
window.customElements.define('graphic-toggle', GraphicToggle);

const STYLESHEET = `
graphic-toggle {
    cursor: pointer;
    user-select: none;

    & > :nth-child(1) {
        display: inline-block;
    }
    & > :nth-child(2) {
        display: none;
    }

    &[checked] > :nth-child(1) {
        display: none;
    }
    &[checked] > :nth-child(2) {
        display: inline-block;
    }

}

`;
